import Pin from './Pin';
import {useContext} from 'react';
import {CatsFilterContext, CurrentPointContext} from './AppContext';

export default function CountryPoints({points}){

  const {catsFilter} = useContext(CatsFilterContext);
  const {currentPoint, setCurrentPoint} = useContext(CurrentPointContext);

  return (
    <>
    {
      points.map(point => {
        if (catsFilter.length && catsFilter.findIndex(catId => catId === point.category) === -1)
          return null;

        const {x, y} = point.coords;
        const scale = currentPoint && currentPoint.id === point.id ? 1.25 : 1;
        return (
          <g key={point.id} transform={`translate(${x}, ${y})`}  onClick={() => setCurrentPoint(point)}>
            <g className="transition-transform duration-300 hover:scale-125" transform={`scale(${scale})`} transform-origin="16 38">
          <Pin point={point} />
            </g>
        </g>
        );
      })
    }
    </>
  );
}